<template>
  <div>
    <Row>
      <Col span="24">
      <div ref="bbox" :class="showSearchLayer?'searchLayerdisp':'searchLayerhide'">
        <Affix :offset-top="10">
          <!--  <Button type="primary" icon="md-search" @click="openEngine" size="small">搜索引擎</Button> -->
          <Dropdown style="margin-left: 0px" @on-click="onDropDownSelect">
            <Button icon="md-search" type="primary" size="small">
              快捷查询
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="search">搜索引擎</DropdownItem>
              <DropdownItem name="upload">上传文件库</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Affix>
      </div>
      <Collapse v-model="workRecordValue" size="large">
        <Panel name="1" size="large" class="cpllapse-panel-title">
          我的工作薄
          <div slot="content">
            <Row>
              <Col span="12">
              <ButtonGroup>
                <Button @click="newWork">新建</Button>
                <Button @click="edit" :disabled="isEdit">查阅/编辑</Button>
                <Button @click="deleteRow" :disabled="isDelete">删除</Button>
                <Button @click="download" :disabled="isDown">下载为word格式</Button>
                <!--   <Button>恢复</Button> -->
              </ButtonGroup>
              </Col>
              <Col span="12"><Input search enter-button="查询" @on-search="cityNextSearch" placeholder="查询我的工作薄..." /></Col>
            </Row>
            <p>&nbsp;</p>
            <div class="demo-spin-container">
              <Table :data="tableData1" :columns="tableColumns1" size="small" @on-selection-change="onSelectionChange" ref="tableSelection" stripe></Table>
              <br />
              <Page :total="pageTotal" :current="1" @on-change="changePage"></Page>
              <Spin fix v-if="spinShow1"></Spin>
            </div>
          </div>
        </Panel>
      </Collapse>
      </Col>
    </Row>
    <br>
    <Row>
      <Col span="24">
      <Collapse v-model="newWorkValue" size="large" :style="{display:newWorkDisp?'block':'none'}">
        <Panel name="1" size="large" class="cpllapse-panel-title">
          {{workbooktitle}}
          <div slot="content">
            <MyMdEditer ref="myedit" @workBookSave="onWorkBookSave" @submitOk="textSubmitOk" @on-workbook-newreadfile="showSearchEngineResult" @onFullScreen="onWorkFullScreen"></MyMdEditer>
          </div>
        </Panel>
      </Collapse>
      </Col>
    </Row>
    <br>
    <Row>
      <Col span="24">
      </Col>
    </Row>
  </div>
</template>
<script>
import recordData from '../../assets/json/workrecords.json'
import SelectData from '../../assets/json/selectData.json'
import mdText from '../../assets/json/markdown.json'
import expandRow from './content_main_list_expandtable.vue'
import MdEditer from './workbook_mkediter.vue'
import { mapGetters } from 'vuex'
import constJson from '../../api/common/constjson.js'
import store from '../../store'
let constJ = new constJson()
export default {
  name: "workbook",
  data() {
    return {
      formItem: {
        industryselected: [],
      },
      tagList: SelectData.industry,
      tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
      tableColumns1: [], //this.mockTableHeader(),
      showHeaders: [],
      // showfilename:false,
      sliders: this.getSliders(),
      newWorkValue: [],
      workRecordValue: ["1"],
      newWorkDisp: false,
      workbooktitle: "",
      mData: {
        text: "6K+36L6T5YWlLi4u"
      },
      spinShow1: false,
      showSearchLayer: false,
      isEdit: true,
      isDelete: true,
      isDown: true,

      pageTotal: 10,
      PageIndex: 1,
      PageSize: 10,
      tabrows: [],
      header: [{
          "title": "标题",
          "key": "title",
          "width": "845",
          "align": "left"
        },
        {
          "title": "首次编写时间",
          "key": "fristedittime",
          "width": "250",
          "align": "left"
        },
        {
          "title": "最近更新时间",
          "key": "lastedittime",
          "width": "250",
          "align": "left"
        },
        {
          "title": "编写至今更新次数",
          "key": "versionseq",
          "width": "200",
          "align": "left"
        }
      ]
    }
  },
  inject: ['CreatePage', 'getSliders'],
  methods: {
    mockTableData1(index) {
      // console.log("this.tabrows")
      // console.log(this.tabrows)
      let da = [];
      let items = this.tabrows
      for (var i = 0; i < items.length; i++) {
        let expand = true
        let checked = false
        if (items[i].versionseq > 1) {
          expand = false; //启用
        }

        if (index !== undefined && i === index) {
          checked = true
        }

        da.push({
          bookid: items[i].bookid,
          fristedittime: items[i].fristedittime,
          title: items[i].title,
          lastedittime: items[i].lastedittime,
          versionseq: items[i].versionseq,
          _disableExpand: expand,
          historyversion: items[i].historyversion,
          bookguid: items[i].bookguid,
          //children: items[i].children,
          _checked: checked,

        })
      }
      return da;
    },
    mockTableHeader(header, headerTitle) {
      let da = [];
      let items = header;
      let newHeaders = [];
      var offset = 0
      //判断是否展开或收缩左侧目录
      if (this.getLeftExpand === undefined) {
        offset = 0
      } else if (!this.getLeftExpand) {
        offset = 45;
      }
      //console.log("offset2:" + offset)
      this.setHeader(headerTitle);
      // if (this.showHeaders.indexOf("checkbtn") >= 0) {
      //   newHeaders.push({
      //     type: 'selection',
      //     //width: 60,
      //     // align: 'center'
      //   })
      // }
      for (var i = 0; i < items.length; i++) {
        // console.log(items[i].key)

        if (this.showHeaders.indexOf(items[i].key) >= 0) {
          newHeaders.push(items[i])
        }
      }

      //console.log(newHeaders)
      items = newHeaders;
      da.push({
        type: 'selection',
        width: 53,
        align: 'left'
      })
      for (var i = 0; i < items.length; i++) {
        let w = parseInt(items[i].width) + offset
        if (items[i].key == "title") {
          // console.log(w)
          da.push({
            title: items[i].title,
            key: items[i].key,
            //width:450,// w + "px",
            align: items[i].align,
            render: (h, params) => {
              const row = params.row;
              const text = row.title;
              const fileid = row.bookid;
              return h('a', {
                on: {
                  'click': () => {
                    this.add(fileid, 2, text);
                    // this.showfilename=true;
                    //this.setHeader('recordname');
                  }
                }
              }, text);
            }
          })

        } else {
          da.push({
            title: items[i].title,
            key: items[i].key,
            //width: w + "px",
            align: items[i].align,
            // className: 'demo-table-info-column',
          })
        }

      }
      da.push({
        type: 'expand',
        align: "left",
        width: 50,
        // className: "expandclass",
        render: (h, params) => {
          // const row = params.row;
          return h(expandRow, {
            style: {
              border: '1px solid #ff9900',
            },
            props: {
              row: params.row,
              from: "workbook"
            }
          })
        }
      })

      return da;
    },
    setHeader(arrayObj) {
      if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
        this.showHeaders = ['bookid', 'checkbtn', 'title', 'fristedittime', 'lastedittime', 'versionseq']
      } else {
        this.showHeaders = arrayObj
      }
      // console.log(this.showHeaders)
    },
    // formatDate (date) {
    //     const y = date.getFullYear();
    //     let m = date.getMonth() + 1;
    //     m = m < 10 ? '0' + m : m;
    //     let d = date.getDate();
    //     d = d < 10 ? ('0' + d) : d;
    //     return y + '-' + m + '-' + d;
    // },
    changePage() {
      this.tableData1 = this.mockTableData1();
    },
    add(fid, orderid, filename) {
      this.CreatePage(fid, orderid, filename);
    },
    reloadHeaderData(obj) {
      this.tableColumns1 = this.mockTableHeader(obj);
    },
    getEditData() {
      return mdText;
    },
    newWork() {
      let bookObj = {
        bookId: 0,
        bookGuid: '',
      }
      this.$refs.myedit.setWorkbookId(bookObj)
      this.$refs.myedit.editorState = 1
      this.$refs.myedit.clearFromData()
      this.clearLocalCacheWorkBook() //清除上一次文档编辑的缓存文件
      this.$refs.myedit.setWrokBookOptions(['1']) //展开工作薄选项
      this.workRecordValue = []
      this.workbooktitle = "新建工作簿"
      this.newWorkDisp = true
      this.newWorkValue = ['1']
      this.clearCheckedRow() //重置因提交产生的选择状态
      this.$refs.myedit.loadText('')
      this.setContentStatefalse()
      this.showSearchLayer = true

    },
    edit() {
      //this.mData=this.getEditData();
      this.clearLocalCacheWorkBook() //清除上一次文档编辑的缓存文件
      let checkrow = this.getSelect()
      if(checkrow.length===0){
        this.$Message.error("请选择需要编辑的工作簿")
        return
      }
      let bookObj = {
        bookId: checkrow[0].bookid,
        bookGuid: checkrow[0].bookguid
      }
      
      this.getWorkBookItems(checkrow[0].bookid)
      this.$refs.myedit.setWorkbookId(bookObj)
      this.$refs.myedit.editorState = 2
      this.$refs.myedit.setWrokBookOptions(['1'])
      this.workRecordValue = []
      this.workbooktitle = "编辑工作簿"
      this.newWorkDisp = true
      this.newWorkValue = ['1']
      //this.$refs.myedit.mockBookHistoryFiles()
      this.showSearchLayer = true
    },
    textSubmitOk() {
      this.workRecordValue = ["1"]
      this.newWorkDisp = false
      this.newWorkValue = []
      this.checkedRow(0)
      this.getUserWorkBookFiles(this.PageIndex)
      this.setContentStatefalse()
      this.clearReadedWorkBook()
      //this.$emit('workBookSubmitOk')
      this.showSearchLayer = false
      //this.$refs.myedit.loadText('')

    },
    clearReadedWorkBook() {
      //console.log('clear...')
      store.state.user.workbook.readfiles = []
      store.state.user.workbook.readfilesSelected = []
    },
    clearLocalCacheWorkBook() {
      //console.log('clear...')
      store.state.user.workbook.historyfiles = []
      store.state.user.workbook.readfiles = []
      store.state.user.workbook.readfilesSelected = []
    },

    onWorkBookSave() {
      //console.log("workbook.save...")
      this.getUserWorkBookFiles(this.PageIndex)
      this.setContentStatefalse()
      //this.clearReadedWorkBook()
      //this.$emit('workBookSave')
    },
    cityNextSearch() {
      this.spinShow1 = true
      var that = this
      setTimeout(function() {
        that.spinShow1 = false
      }, 1000)
    },

    showdialog(title, content,funcOk) {
      this.$Modal.confirm({
        title: title,
        content: '<p>' + content + '</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          funcOk()
        },
        onCancel: () => {
          return
          // this.$Message.info('Clicked cancel');
        }
      });
    },

    deleteRow() {
      let checkrow = this.getSelect()
      if(checkrow.length===0){
        this.$Message.error("请选择需要删除的工作簿")
        return
      }

      this.showdialog("提示", "您确定要删除么？",this.delrow)

      // let rows = this.getSelect()
      // if (rows !== null && rows !== undefined && rows.length > 0) {
      //   for (let i = 0; i < rows.length; i++) {
      //     var item = {
      //       bookid: 0, //rows[i].bookid,
      //       bookguid: rows[i].bookguid,
      //     }
      //     items.push(item)
      //   }
      // }
      // this.deleteWorkBook(items)


      //console.log(items)
      //this.$Message.success('删除<' + o[0].recordname + '>成功');
    },

    delrow() {
      //console.log("del...")

      let items = []
      let rows = this.getSelect()
      if (rows !== null && rows !== undefined && rows.length > 0) {
        for (let i = 0; i < rows.length; i++) {
          var item = {
            bookid: 0, //rows[i].bookid,
            bookguid: rows[i].bookguid,
          }
          items.push(item)
        }
      }
      this.deleteWorkBook(items)

    },

    download() {
      var o = this.getSelect()
      if(o.length===0){
        this.$Message.error("请选择需要下载的工作簿")
        return
      }
      //console.log(o)
      //this.modalPages=true
      this.$refs.myedit.showDownLoadFiles(o)
      // this.$Modal.confirm({
      //   title: "提示信息",
      //   content: "是否将关联的附件一并下载?",
      //   cancelText: "仅下载工作薄文件",
      //   okText: "下载文件及附件",
      //   onOk: function() {
      //     this.$Message.success('下载<' + o[0].recordname + '>文件及附件成功');
      //   },
      //   onCancel: function() {
      //     this.$Message.success('下载<' + o[0].recordname + '>文件成功');
      //   }
      // })


    },
    getSelect() {
      return this.$refs.tableSelection.getSelection()
    },
    showSearchEngineResult() {
      this.$emit('on-workbook-newreadfile')
    },
    checkedRow(index) {
      this.tableData1 = this.mockTableData1(index);
    },
    clearCheckedRow() {
      this.tableData1 = this.mockTableData1();
    },
    openEngine() {
      this.$refs.myedit.openEngine();
    },
    onDropDownSelect(name) {
      // console.log(name)
      if (name === "search") {
        this.openEngine()
      } else if (name === "upload") {
        this.$emit('openUpload')
      }
    },
    onSelectionChange(selection) {
      if (selection.length === 1) {
        this.isEdit = false
        this.isDelete = false
        this.isDown = false
      } else if (selection.length > 1) {
        this.isEdit = true
        this.isDelete = false
        this.isDown = true
      } else {
        this.isEdit = true
        this.isDelete = true
        this.isDown = true
      }
    },
    onWorkFullScreen(tag) {
      this.workRecordValue = []
      //this.$emit('onFullScreen',tag)
    },
    setContentStatefalse() {
      if (store.state.user.workbook.isContentChanged) {
        // console.log("set workbook false")
        store.commit('setWorkBook', false)
      }
    },

    deleteWorkBook(items) {
      constJ.workBookDelete(items).then(res => {
        //console.log(res)
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            this.$Message.success('删除成功');
            this.getUserWorkBookFiles(this.PageIndex)
            //this.reload()
          } else {
            this.$Message.error(res.rltdesc);
            return
          }
        } else {
          this.$Message.error(res.rtndesc);
          return
        }
      })
    },
    getWorkBookItems(bookid) {
      constJ.getWorkBookItemsById(bookid).then(res => {
        console.log(res)
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            //console.log(res.contenttext)
            this.$refs.myedit.mockBookHistoryFiles(res.appendix)
            this.$refs.myedit.formDataFill(res)
            this.$refs.myedit.loadText(res.contenttext)
          } else {
            this.$Message.error(res.rltdesc);
            return
          }
        } else {
          this.$Message.error(res.rtndesc);
          return
        }
      })
    },
    getUserWorkBookFiles(index) {
      let currentIndex = index
      constJ.reqGetWorkBookFiles(this.PageSize, currentIndex).then(res => {
        //console.log(res)
        var obj = null
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            if (res.tbls.length > 0) {
              this.tabrows = res.tbls[0].items
              obj = {
                header: this.header, //this.mockTableHeader(), //testData2.header,
                tabrows: res.tbls[0].items,
                total: res.tbls[0].total,
                //classid: id,
                tabname: "newfiles",
              }
            } else {
              //默认
              obj = {
                header: this.header, //testData2.header,
                tabrows: null,
                total: 0,
                //classid: id,
                tabname: "newfiles",
              }
            }
          } else {

          }
        } else {
          if (res.rtncode === -99) {
            //服务端返回未登录，注销session
            store.commit('setUserLogout')
            return
          }
        }
        this.show(obj)
        //console.log(obj)
        // return obj
      }).catch(err => {
        console.log(err)
      })
    },

    show(data) {
      // console.log("work content...")
      // console.log(data.total)
      // this.classId=data.classid
      this.tableName = data.tabname
      this.pageTotal = data.total
      //this.tableData1 = this.mockTableData1(data.tabrows)
      this.tableData1 = this.mockTableData1()
      // console.log("mockTableData1")
      // console.log(this.tableData1)
      //在路由切换时存在已分屏的情况，在已分屏情况下需要判断是否处于分屏在渲染table的header
      if (this.sliders.length > 0) {
        this.tableColumns1 = this.mockTableHeader(data.header, ['title'])
      } else {
        this.tableColumns1 = this.mockTableHeader(data.header, null)
      }

      this.$nextTick(() => {

      })

    },

    // rowClassName(row, index) {
    //   // console.log(index)
    //   if (index === 1) {
    //     return 'demo-table-info-row';
    //   } else if (index === 3) {
    //     return 'demo-table-error-row';
    //   }
    //   return '';
    // }
  },
  created() {
    if (store.state.user.userId !== undefined && store.state.user.userId !== "") {
      this.getUserWorkBookFiles(1)
    }

  },
  computed: {
    ...mapGetters(['getLeftExpand'])
  },
  watch: {
    sliders: function() {
      //console.log('wookbook')
      this.getUserWorkBookFiles(this.PageIndex)
      if (this.sliders.length == 0) {
        this.reloadHeaderData([]);
      } else if (this.sliders.length > 0) {
        this.reloadHeaderData(['title']);
      }
    },
    getLeftExpand: function() {
      // console.log("wc："+this.getLeftExpand)
      this.getUserWorkBookFiles(this.PageIndex)
      if (this.sliders.length == 0) {
        this.reloadHeaderData([]);
      } else if (this.sliders.length > 0) {
        this.reloadHeaderData(['title']);
      }
    }
  },
  components: {
    expandRow,
    'MyMdEditer': MdEditer,
  },
}

</script>
<style scoped>
.expandclass {
  background-color: white;
}

.demo-spin-container {
  display: inherit;
  width: auto;
  height: auto;
  position: relative;
  /* border: 1px solid #eee;*/
}

.searchLayerdisp {
  position: fixed;
  margin: 8px 150px;
  z-index: 666;
  display: block;
}

.searchLayerhide {
  position: fixed;
  margin: 8px 150px;
  z-index: 666;
  display: none;
}

</style>
